import Vue from 'vue';
import dayjs from 'dayjs';

/**
 * 格式化日期时间
 * @param {Date|String｜Oject} value 日期时间值
 * @param {String} pattern 日期时间格式
 */
Vue.filter('formatDateTime', (value, pattern = 'YYYY/MM/DD HH:mm') => {
  const dateTime = dayjs(value);
  if (!dateTime.isValid()) {
    return '';
  }
  return dateTime.format(pattern);
});

/**
 * 距离现在时间
 * @param {Date|String｜Oject} value 日期时间值
 */
Vue.filter('dateTimeFromNow', (value) => {
  const dateTime = dayjs(value);
  if (!dateTime.isValid()) {
    return '';
  }
  return dateTime.fromNow().replace(/\s+/g, '');
});

/**
 * 1.<10000，直接显示
 * 2.>=10000且<1千万，x.x万，四舍五入
 * 3.>=1千万，x.x千万，四舍五入
 */
Vue.filter('numberFormat', (value) => {
  if (!value) return 0;
  if (value < 10000) return value;
  const val = parseInt(value, 10).toString();

  // >=10000且<1千万，x.x万，四舍五入
  if (val.length < 8) {
    const result = (value / 10000).toFixed(1);
    return result.split('.')[1] !== '0' ? `${result}万` : `${result.split('.')[0]}万`;
  }
  // >=1千万，x.x千万，四舍五入
  const result = (value / 10000000).toFixed(1);
  return result.split('.')[1] !== '0' ? `${result}千万` : `${result.split('.')[0]}千万`;
});

/**
 * 价格格式
 * 0：¥0.00
 * 四舍五入：保留两位小数
 */
Vue.filter('priceFormat', (value) => {
  if (!value) return '¥0.00';
  return `¥${(value).toFixed(2).trim()}`;
});

/**
 * 价格格式
 * 0：¥0.00
 * 四舍五入：保留两位小数
 */
Vue.filter('fillZero', (value) => {
  if (value > 10) return value;
  if (!value) { return '00'; }
  return value.toString().replace(/^([1-9])$/, '0$1');
});
